import { render } from "./InputTypeComponent.vue?vue&type=template&id=07a5b578&scoped=true"
import script from "./InputTypeComponent.vue?vue&type=script&lang=js"
export * from "./InputTypeComponent.vue?vue&type=script&lang=js"

import "./InputTypeComponent.vue?vue&type=style&index=0&id=07a5b578&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a5b578"]])

export default __exports__